import DimensionHeader from "@/components/dimension-header";
import { useApplicationByEdition } from "@/hooks/application-by-edition.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useDimensionByQuizId } from "@/hooks/dimension-by-quiz-id.hook";
import { getDimensionById } from "@/lib/dimensions";
import TopicAccordionItem from "@/modules/quiz/dimension/topic-accordion-item";
import { DimensionId } from "@/types/questionnaries";
import { useParams } from "react-router-dom";
import QuizHistoryPreviewSkeleton from "./quiz-history-preview-skeleton";

const QuizHistoryPreview = () => {
  const { editionId = "", dimensionId: dimensionIdParam } = useParams();

  const dimensionId = dimensionIdParam as DimensionId | undefined;

  const dimension = dimensionId ? getDimensionById(dimensionId) : null;

  if (!dimensionIdParam) {
    throw new Error('No se especificó el parámetro "dimensión');
  }

  if (!dimension) {
    throw new Error("No se encontró la dimensión");
  }

  const { data: userProfile } = useCurrentUserProfile();

  const { data: application } = useApplicationByEdition({
    companyId: userProfile?.companyId || "",
    editionId: editionId,
  });

  const { data: dimensionSummary, isLoading: isDimensionSummaryLoading } =
    useDimensionByQuizId({
      companyId: userProfile?.companyId || "",
      applicationQuizId: application?.quizId || "",
      dimension: dimensionId || "",
    });

  if (isDimensionSummaryLoading) {
    return <QuizHistoryPreviewSkeleton />;
  }

  return (
    <>
      <DimensionHeader
        dimensionId={dimension.id}
        quizId={application?.quizId || ""}
        className="mb-4"
      />

      {Array.isArray(dimensionSummary?.topics) && (
        <div className="flex flex-col gap-5">
          {dimensionSummary.topics.map((topic, index) => (
            <TopicAccordionItem
              key={topic.topic}
              topic={topic}
              order={index + 1}
              disabled={true}
              showResults={dimensionSummary.group !== "GENERAL_INFORMATION"}
              showEvidences={dimensionSummary.group !== "GENERAL_INFORMATION"}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default QuizHistoryPreview;
